import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../types/redux";
import RecentTransactions from "./RecentTransactions";
import { FEATURE_FLAGS } from "../../constants/featureFlags";
import OldRecentTransactions from "./OldRecentTransactions";

const RecentTransactionsHandler = () => {
  const featureFlags = useSelector((state: RootState) => state.user.featureFlags);

  return (
    <>
      {featureFlags?.includes(FEATURE_FLAGS.RECENT_TRANSACTIONS_WEB_KILLSWITCH)
        ? <OldRecentTransactions />
        : <RecentTransactions />
      }
    </>
  );
}

export default RecentTransactionsHandler;